var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2219 2.34695L7.59692 7.97195C7.51854 8.05061 7.42539 8.11303 7.32283 8.15561C7.22027 8.1982 7.11032 8.22012 6.99927 8.22012C6.88822 8.22012 6.77826 8.1982 6.6757 8.15561C6.57314 8.11303 6.48 8.05061 6.40161 7.97195L0.77661 2.34695C0.618102 2.18845 0.529053 1.97346 0.529053 1.7493C0.529053 1.52513 0.618102 1.31015 0.77661 1.15164C0.935118 0.993133 1.1501 0.904085 1.37427 0.904085C1.59843 0.904085 1.81341 0.993133 1.97192 1.15164L6.99997 6.17969L12.028 1.15094C12.1865 0.992431 12.4015 0.903381 12.6257 0.903381C12.8498 0.903381 13.0648 0.992431 13.2233 1.15094C13.3818 1.30945 13.4709 1.52443 13.4709 1.7486C13.4709 1.97276 13.3818 2.18774 13.2233 2.34625L13.2219 2.34695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.fc07928cd89ee2c783a02ee61cf8714a.svg";
export { ForwardRef as ReactComponent };